export const ACCOUNT_SUBSCRIPTION_PATH = '/my/project/settings/subscription'
